import React from "react"
import usePrevious from "@myvp/shared/src/hooks/use-previous"
import useInitialMount from "@myvp/shared/src/hooks/use-initial-mount"
import useRefCallback from "@myvp/shared/src/hooks/use-ref-callback"
import { dequal } from "dequal/lite"

const useDidUpdate = <T>(
  current: T,
  callback: (prev: T | undefined, current: T) => void,
  {
    runOnInitialMount = false,
    active = true,
    equalityType = "deep",
  }: {
    runOnInitialMount?: boolean
    active?: boolean
    equalityType?: "deep" | "reference"
  } = {}
) => {
  const refCallback = useRefCallback(callback)
  const prev = usePrevious(current)
  const isInitialMount = useInitialMount()
  React.useEffect(() => {
    const hasChanges =
      equalityType === "deep" ? !dequal(prev, current) : prev !== current
    if (active && (runOnInitialMount || !isInitialMount) && hasChanges) {
      refCallback.current?.(prev, current)
    }
  }, [isInitialMount, current, prev, runOnInitialMount, active, equalityType])
}

export default useDidUpdate
